import React from 'react';
import Icon from '../../../components/AppIcon';

const OverviewCard = ({ 
  title, 
  value, 
  icon, 
  trend, 
  trendValue, 
  status = 'default',
  onClick,
  className = "" 
}) => {
  const getStatusColor = () => {
    switch (status) {
      case 'success':
        return 'border-success/20 bg-success/5';
      case 'warning':
        return 'border-warning/20 bg-warning/5';
      case 'error':
        return 'border-error/20 bg-error/5';
      default:
        return 'border-border bg-card';
    }
  };

  const getTrendColor = () => {
    if (!trend) return 'text-muted-foreground';
    return trend === 'up' ? 'text-success' : trend === 'down' ? 'text-error' : 'text-muted-foreground';
  };

  const getTrendIcon = () => {
    if (!trend) return null;
    return trend === 'up' ? 'TrendingUp' : trend === 'down' ? 'TrendingDown' : 'Minus';
  };

  return (
    <div 
      className={`
        ${getStatusColor()} border rounded-lg p-6 security-shadow-card security-transition
        ${onClick ? 'cursor-pointer hover:shadow-lg' : ''}
        ${className}
      `}
      onClick={onClick}
    >
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-muted-foreground mb-1">{title}</p>
          <p className="text-2xl font-bold text-foreground">{value}</p>
          
          {trend && trendValue && (
            <div className={`flex items-center space-x-1 mt-2 ${getTrendColor()}`}>
              <Icon name={getTrendIcon()} size={16} />
              <span className="text-sm font-medium">{trendValue}</span>
              <span className="text-xs text-muted-foreground">vs last hour</span>
            </div>
          )}
        </div>
        
        <div className={`
          w-12 h-12 rounded-lg flex items-center justify-center
          ${status === 'success' ? 'bg-success/10 text-success' : 
            status === 'warning' ? 'bg-warning/10 text-warning' :
            status === 'error'? 'bg-error/10 text-error' : 'bg-primary/10 text-primary'}
        `}>
          <Icon name={icon} size={24} />
        </div>
      </div>
    </div>
  );
};

export default OverviewCard;